import { SearchRoadRoutingRequestWaypointCoordinate } from "../../../../../../../common/utils/search-road-route/search-road-routing.request";
import OrderRouteEditPassenger from "../../../types/order-route-edit-passenger";
import OrderRouteEditSummaryRouteWaypoint from "../route/types/order-route-edit-summary-route-waypoint";
import OrderRouteEditSummaryConnectedWaypoints from "./types/order-route-edit-summary-connected-waypoints";

const getPassengersListLabel = (
  selectedPassengers: OrderRouteEditPassenger[]
) => {
  if (!selectedPassengers.length) {
    return `-----`;
  }

  const selectedPassengersDisplayNames = selectedPassengers.map(
    (passenger) => `${passenger.firstName} ${passenger.lastName}`
  );

  return selectedPassengersDisplayNames.join(`, `);
};

const getOrderNumberLabel = (orderNumber: string) => {
  if (!orderNumber) {
    return `-----`;
  }

  return orderNumber;
};

const getNotesForTaxiLabel = (notesForTaxi: string) => {
  if (!notesForTaxi) {
    return `-----`;
  }

  return notesForTaxi;
};

const getInternalRemarksLabel = (internalRemarks: string) => {
  if (!internalRemarks) {
    return `-----`;
  }

  return internalRemarks;
};

const getWaypointGroupsCouldBeConnected = (
  waypoints: OrderRouteEditSummaryRouteWaypoint[]
) => {
  let waypointGroups: OrderRouteEditSummaryConnectedWaypoints[] = [];

  waypoints.forEach((waypoint, index) => {
    const nextWaypoint = waypoints[index + 1];

    if (!nextWaypoint) {
      return;
    }

    const isWaypointAndNextWaypointSameStageNo =
      waypoint.stageNo === nextWaypoint.stageNo;
    const isWaypointAlone =
      waypoints.filter((w) => w.stageNo === waypoint.stageNo).length === 1;
    const isNextWaypointAlone =
      waypoints.filter((w) => w.stageNo === nextWaypoint.stageNo).length === 1;

    const isPlaceInWaypoint = !!waypoint.place;
    const isPlaceInNextWaypoint = !!nextWaypoint.place;

    if (
      !isWaypointAndNextWaypointSameStageNo &&
      isWaypointAlone &&
      isNextWaypointAlone &&
      isPlaceInWaypoint &&
      isPlaceInNextWaypoint
    ) {
      waypointGroups.push({ start: waypoint, end: nextWaypoint });
    }
  });

  return waypointGroups;
};

const getCoordinatesOfWaypointsCouldBeConnected = (
  connectedWaypoints: OrderRouteEditSummaryConnectedWaypoints[]
): SearchRoadRoutingRequestWaypointCoordinate[][] => {
  let coordinatesOfWaypointsCouldBeConnected: SearchRoadRoutingRequestWaypointCoordinate[][] =
    [];

  connectedWaypoints.forEach((connection) => {
    const start = {
      latitude: connection.start.place!.latitude,
      longitude: connection.start.place!.longitude,
    };

    const end = {
      latitude: connection.end.place!.latitude,
      longitude: connection.end.place!.longitude,
    };

    const newGroup: SearchRoadRoutingRequestWaypointCoordinate[] = [start, end];

    coordinatesOfWaypointsCouldBeConnected.push(newGroup);
  });

  return coordinatesOfWaypointsCouldBeConnected;
};

const orderRouteEditSummaryHelper = {
  getPassengersListLabel,
  getOrderNumberLabel,
  getNotesForTaxiLabel,
  getInternalRemarksLabel,
  getWaypointGroupsCouldBeConnected,
  getCoordinatesOfWaypointsCouldBeConnected,
};

export default orderRouteEditSummaryHelper;
